ui-cms-standard-teaser {
  $content-gap: $sd-spacing-5;

  display: block;

  a {
    color: inherit;
    text-decoration: none;
    display: block;
    height: 100%;
  }

  .standard-teaser {
    height: 100%;
    container-type: inline-size;
    container-name: standard-teaser-container;

    &--horizontal-variant-spacing {
      &::part(media),
      &::part(content) {
        margin: $sd-spacing-6;

        @container standard-teaser-container (max-width:800px) {
          margin: $sd-spacing-4;
        }
      }
    }

    &--vertical-variant-spacing {
      &::part(media) {
        margin-bottom: 0;
      }

      &::part(content) {
        margin: $sd-spacing-4;
      }
    }

    &::part(base) {
      height: 100%;
      overflow: hidden;
      padding: 0;
    }

    &::part(content) {
      overflow: hidden;
      padding: 0;
      gap: $content-gap;
      flex-grow: 1;
    }

    &::part(meta) {
      display: flex;
    }

    &::part(main) {
      display: flex;
      flex-direction: column;
      gap: $content-gap;
    }

    sd-video {
      display: block;

      video {
        width: 100%;
        display: block;
      }
    }

    &__headline {
      padding-top: $sd-spacing-1;
      margin-bottom: $sd-spacing-1;
    }

    &--media-position-right {
      &::part(base) {
        flex-direction: row-reverse;
      }

      &::part(media) {
        margin-left: 0;
      }

      &::part(content) {
        margin-right: 0;
      }
    }

    &--media-position-left {
      &::part(media) {
        margin-right: 0;
      }

      &::part(content) {
        margin-left: 0;
      }
    }

    &--no-spacing {
      &-vertical {
        &::part(media) {
          margin: 0;
        }

        &::part(content) {
          margin-top: $sd-spacing-4;
        }
      }

      &-horizontal {
        &::part(media),
        &::part(content) {
          margin: 0;
        }
      }
    }

    &--no-media-spacing {
      &::part(media) {
        margin: 0;
      }
    }

    &--meta-position-bottom {
      &::part(meta) {
        display: none;
      }

      &::part(headline) {
        margin-top: -0.45rem;
      }
    }

    &__media {
      position: relative;
      overflow: hidden;
      width: 100%;

      &__chip {
        position: absolute;
        top: $sd-spacing-3;
        left: $sd-spacing-4;
      }

      &__flag {
        position: absolute;
        top: $sd-spacing-2;
        right: 0;
      }

      &__icon {
        height: 210px;
        font-size: 96px;
        display: flex;
        justify-content: center;
        align-items: center;

        @container standard-teaser-container (max-width:500px) {
          height: 160px;
        }

        &--size-big {
          font-size: 120px;
        }

        &--align-left {
          justify-content: flex-start;
          align-items: flex-end;
        }
      }

      iframe {
        display: block;
      }
    }

    &__content-chips {
      display: flex;
      gap: $sd-spacing-2;
    }

    &__links {
      display: flex;
      flex-direction: column;
      gap: $content-gap;
      margin-top: auto;

      &--align-right {
        align-items: flex-end;
      }
    }

    &--align-links-bottom {
      &::part(main) {
        height: 100%;
      }
    }

    &--vertical-alignment {
      &::part(media) {
        display: flex;
        align-items: center;
      }

      &::part(content) {
        justify-content: center;
      }
    }

    &--exclude-content-main {
      &::part(main) {
        display: none;
      }
    }

    &--exclude-meta {
      &::part(meta) {
        display: none;
      }
    }

    ui-cms-link sd-button {
      width: auto;
    }

    &__bottom-meta-spacing {
      margin-top: $sd-spacing-5;
    }
  }
}
